import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dot",
  "use": "dot-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" fill=\"currentColor\" id=\"dot\"><path d=\"M512 384.69984558c70.01508493 0 127.30015442 57.28506949 127.30015442 127.30015442S582.01508493 639.30015442 512 639.30015442 384.69984558 582.01508493 384.69984558 512 441.98491507 384.69984558 512 384.69984558z\" p-id=\"1472\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol